import type { SportProfile } from '@/types'
import { lacrosseMens } from './lacrosse-mens'
import { lacrosseWomens } from './lacrosse-womens'
import { lacrosseBox } from './lacrosse-box'
import { soccerMens } from './soccer-mens'
import { soccerWomens } from './soccer-womens'
import { basketballMens } from './basketball-mens'
import { basketballWomens } from './basketball-womens'
import { fieldHockey } from './field-hockey'
import { volleyball } from './volleyball'
import { iceHockey } from './ice-hockey'
import { rugbyUnion } from './rugby-union'
import { rugbyLeague } from './rugby-league'
import { baseball } from './baseball'
import { softballFastpitchWomens } from './softball-fastpitch-womens'
import { softballFastpitchMens } from './softball-fastpitch-mens'
import { softballSlowpitchMens } from './softball-slowpitch-mens'
import { softballSlowpitchCoed } from './softball-slowpitch-coed'

export const sportProfiles: SportProfile[] = [
  lacrosseMens,
  lacrosseWomens,
  lacrosseBox,
  soccerMens,
  soccerWomens,
  basketballMens,
  basketballWomens,
  fieldHockey,
  volleyball,
  iceHockey,
  rugbyUnion,
  rugbyLeague,
  baseball,
  softballFastpitchWomens,
  softballFastpitchMens,
  softballSlowpitchMens,
  softballSlowpitchCoed,
]

export const sportProfileMap: Record<string, SportProfile> = Object.fromEntries(
  sportProfiles.map((p) => [p.id, p])
)

export function getSportProfile(id: string): SportProfile | undefined {
  return sportProfileMap[id]
}

export function getSportsByCategory() {
  const categories: Record<string, SportProfile[]> = {}
  for (const profile of sportProfiles) {
    if (!categories[profile.sport]) categories[profile.sport] = []
    categories[profile.sport].push(profile)
  }
  return categories
}

export { lacrosseMens, lacrosseWomens, lacrosseBox, soccerMens, soccerWomens, basketballMens, basketballWomens, fieldHockey, volleyball, iceHockey, rugbyUnion, rugbyLeague, baseball, softballFastpitchWomens, softballFastpitchMens, softballSlowpitchMens, softballSlowpitchCoed }
